<template>
  <div>
    <div class="start-page">
    <div v-if="loader" class="loader">
      <b-spinner
        variant="primary"
        type="grow"
        :label="`${this.$t('reports.loadingLabel')}...`"
      ></b-spinner>
    </div>
    <div v-else-if="chartOptions && !loader && data.series.length > 0">
      <b-form-checkbox
        class="right-switch"
        style="padding-right: 20px;"
        v-model="checked"
        name="check-button"
        switch
      >
        Visualizar conversão
      </b-form-checkbox>

      <span class="right-switch" id="popover-target-1">
        <font-awesome-icon
          :icon="['fas', 'info-circle']"
          style="font-size: 15px; color: #c1c1c1;"
        />
      </span>

      <b-popover target="popover-target-1" triggers="hover" placement="top">
        <span
          ><b>Taxa de conversão: </b> convites respondidos/total de convites *
          100
        </span>
      </b-popover>

      <highcharts :options="chartOptions"></highcharts>
    </div>
  </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import eventBus from '../../../../eventBus';

export default {
  name: 'InviteEvolution',
  props: ['reportType', 'accumulated'],
  data: () => ({
    chartOptions: null,
    loader: true,
    legend: '',
    type: 'column',
    monthly: false,
    // reportType: 'day',
    checked: false,
    data: null,
  }),
  watch: {
    actionGroupData: function watchActionGroup() {
      this.prepareChart();
    },
    myActionId: function watchMyActionId() {
      this.prepareChart();
    },
    myActionsIds: function watchMyActionsIds() {
      this.prepareChart();
    },
    myIh1: function watchMyIh1() {
      this.prepareChart();
    },
    myHierarchies1: function watchMyHierarchies1() {
      this.prepareChart();
    },
    myIh2: function watchMyIh2() {
      this.prepareChart();
    },
    myHierarchies2: function watchMyHierarchies2() {
      this.prepareChart();
    },
    calendarDates: function watchDates() {
      this.prepareChart();
    },
    myMetric: function watchMyMetric() {
      this.prepareChart();
    },
    'indicatorData.value': function watchIndicatorData() {
      this.prepareChart();
    },
    'indicatorData.period': async function watchIndicatorPeriod() {
      await this.prepareChart();
    },
    accumulated: async function watchAccumulated() {
      await this.prepareChart();
      this.checked = false;
    },
    checked: async function watchSwitchChecked(value) {
      if (value) {
        this.chartOptions.yAxis[0] = {
          title: {
            text: '',
            style: {
              color: 'blue',
            },
          },
        };

        if (this.accumulated) {
          this.chartOptions.series.push({
            name: '%Conversão',
            dataLabels: {
              enabled: true,
              format: '{y:.2f}%',
            },
            type: 'spline',
            data: this.data.answeredAccumulated,
            color: '#17a2b8',
          });
        } else {
          this.chartOptions.series.push({
            name: '%Conversão',
            dataLabels: {
              enabled: true,
              format: '{y:.2f}%',
            },
            type: 'spline',
            data: this.data.answered,
            color: '#17a2b8',
          });
        }
      } else if (this.chartOptions.series.length === 2) {
        this.chartOptions.series.pop({
          name: '%Conversão',
        });
      }
    },
  },
  computed: {
    ...mapState('charts', ['invitesEvolution']),
    ...mapState('actions', ['myActionId', 'actionGroupData', 'myActionsIds']),
    ...mapState('branches', ['myIh1', 'myIh2', 'myHierarchies1', 'myHierarchies2']),
    ...mapState('calendar', ['calendarDates']),
    ...mapState('companies', ['myMetric']),
    ...mapState('indicators', ['indicatorName', 'indicatorData']),
  },
  methods: {
    ...mapActions('charts', [
      'evolutionDailyInvites',
      'evolutionPeriodInvites',
    ]),
    ...mapActions('calendar', ['setDefaultDates']),
    prepareChart() {
      switch (this.reportType) {
        case 'day':
          if (this.accumulated) {
            this.legend = `- ${this.$t('reports.accDailyLabel')}`;
          } else {
            this.legend = `- ${this.$t('reports.dailyLabel')}`;
          }
          this.setColumnsPeriod();
          break;
        case 'week':
          if (this.accumulated) {
            this.legend = `- ${this.$t('reports.accWeeklyLabel')}`;
          } else {
            this.legend = `- ${this.$t('reports.weeklyLabel')}`;
          }
          this.checked = false;
          this.setColumnsPeriod();
          break;
        case 'month':
          if (this.accumulated) {
            this.legend = `- ${this.$t('reports.accMonthlyLabel')}`;
          } else {
            this.legend = `- ${this.$t('reports.monthlyLabel')}`;
          }
          this.checked = false;
          this.setColumnsPeriod();
          break;
        case 'quarter':
          if (this.accumulated) {
            this.legend = `- ${this.$t('reports.accQuarterlyLabel')}`;
          } else {
            this.legend = `- ${this.$t('reports.quarterlyLabel')}`;
          }
          this.checked = false;
          this.setColumnsPeriod();
          break;
        default:
          break;
      }
    },
    async setColumns() {
      this.loader = true;
      await this.evolutionDailyInvites({
        companyId: this.userAuth.companyId,
        actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
        token: this.userAuth.token,
        ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
        ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
        startDate: this.calendarDates.start ? this.calendarDates.start : null,
        endDate: this.calendarDates.end ? this.calendarDates.end : null,
        metric: this.myMetric ? this.myMetric : null,
        groupId: this.actionGroupData._id,
        indicator: this.indicatorName,
        indicatorValue: this.indicatorData.value,
        indicatorRange: this.indicatorData.range,
      })
        .then(() => {
          if (this.accumulated) {
            this.renderChart({
              categories: this.invitesEvolution.categories,
              series: this.invitesEvolution.seriesAccumulated,
            });
          } else {
            this.renderChart({
              categories: this.invitesEvolution.categories,
              series: this.invitesEvolution.series,
            });
          }

          this.data = this.invitesEvolution;

          this.loader = false;
        })
        .catch(() => {
          this.loader = false;
        });
    },

    async setColumnsPeriod() {
      this.loader = true;

      this.evolutionPeriodInvites({
        companyId: this.userAuth.companyId,
        actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
        token: this.userAuth.token,
        ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
        ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
        startDate: this.calendarDates.start ? this.calendarDates.start : null,
        endDate: this.calendarDates.end ? this.calendarDates.end : null,
        metric: this.myMetric ? this.myMetric : null,
        groupId: this.actionGroupData._id,
        indicator: this.indicatorName,
        indicatorValue: this.indicatorData.value,
        indicatorRange: this.indicatorData.range,
        reportType: this.reportType,
      })
        .then(() => {
          if (this.accumulated) {
            this.renderChart({
              categories: this.invitesEvolution.categories,
              series: this.invitesEvolution.seriesAccumulated,
            });
          } else {
            this.renderChart({
              categories: this.invitesEvolution.categories,
              series: this.invitesEvolution.series,
            });
          }

          this.data = this.invitesEvolution;

          this.loader = false;
        })
        .catch(() => {
          this.loader = false;
        });
    },

    async renderChart(data) {
      if (data.series.length > 0) {
        const max = data.series.reduce((a, b) => Math.max(a, b));

        this.checked = false;

        this.chartOptions = {
          title: {
            align: 'left',
            text: `${this.$t('reports.invitesEvolution.reportTitle')}
            ${this.legend}`,
            style: {
              color: '#5f6368',
            },
          },
          chart: {
            type: this.type,
            borderColor: 'rgba(0, 0, 0, 0.09)',
            style: {
              fontFamily:
                '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"',
              fontSize: '12px',
              width: '100%',
            },
          },
          xAxis: {
            categories: data.categories,
            visible: true,
            labels: {},
          },
          yAxis: [
            {
              // Primary yAxis
            },
            {
              // Secondary yAxis
              max,
              min: 0,
              gridLineWidth: 0,
              labels: {
                enabled: false,
              },
              title: {
                text: '',
              },
              stackLabels: {
                enabled: true,
                fontWeight: 'bold',
              },
            },
          ],
          series: [
            {
              name: this.$t('reports.inviteLabel'),
              data: data.series,
            },
          ],
          legend: {
            enabled: true,
          },
          plotOptions: {
            column: {
              pointPadding: 0.1,
              borderWidth: 0,
              yAxis: 1,
              dataLabels: {
                enabled: true,
                format: '{y:.0f}',
              },
              tooltip: {
                pointFormat: '<span>{series.name}<b> {point.y:.0f}<b/> <br/>',
                shared: true,
              },
              showInLegend: true,
            },
            line: {
              dataLabels: {
                enabled: true,
                format: '{y:.0f}',
              },
              yAxis: 1,
              tooltip: {
                pointFormat: '<span>{series.name}<b> {point.y:.0f}<b/> <br/>',
                shared: true,
              },
              showInLegend: true,
            },
            area: {
              dataLabels: {
                enabled: true,
                format: '{y:.0f}',
              },
              yAxis: 1,
              tooltip: {
                pointFormat: '<span>{series.name}<b> {point.y:.0f}<b/> <br/>',
                shared: true,
              },
              showInLegend: true,
            },
            series: {
              groupPadding: 0,
              pointPadding: 0.05,
              borderWidth: 0,
            },
          },
          colors: ['#4ce595'],
        };
      }
    },
    getLegend() {
      switch (this.reportType) {
        case 'day':
          if (this.accumulated) {
            this.legend = `- ${this.$t('reports.accDailyLabel')}`;
          } else {
            this.legend = `- ${this.$t('reports.dailyLabel')}`;
          }
          break;
        case 'week':
          if (this.accumulated) {
            this.legend = `- ${this.$t('reports.accWeeklyLabel')}`;
          } else {
            this.legend = `- ${this.$t('reports.weeklyLabel')}`;
          }
          break;
        case 'month':
          if (this.accumulated) {
            this.legend = `- ${this.$t('reports.accMonthlyLabel')}`;
          } else {
            this.legend = `- ${this.$t('reports.monthlyLabel')}`;
          }
          break;
        case 'quarter':
          if (this.accumulated) {
            this.legend = `- ${this.$t('reports.accQuarterlyLabel')}`;
          } else {
            this.legend = `- ${this.$t('reports.quarterlyLabel')}`;
          }
          break;
        default:
          break;
      }
    },
  },

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
    this.getLegend();
  },

  async mounted() {
    this.loader = true;

    await this.prepareChart();

    eventBus.$on('accumulated-report', (checked) => {
      this.accumulated = checked;
      switch (this.accumulated) {
        case true:
          this.renderChart({
            categories: this.invitesEvolution.categories,
            series: this.invitesEvolution.seriesAccumulated,
          });
          break;
        case false:
          this.renderChart({
            categories: this.invitesEvolution.categories,
            series: this.invitesEvolution.series,
          });
          break;
        default:
          this.legend = ' ';
      }
    });
    eventBus.$on('data-source', (checked) => {
      this.reportType = checked;
      this.prepareChart();
    });
    eventBus.$on('switch-chart', (chart) => {
      this.type = chart;
      this.loader = true;
      if (this.accumulated) {
        this.renderChart({
          categories: this.invitesEvolution.categories,
          series: this.invitesEvolution.seriesAccumulated,
        });
      } else {
        this.renderChart({
          categories: this.invitesEvolution.categories,
          series: this.invitesEvolution.series,
        });
      }

      this.loader = false;
    });

    // this.loader = false;
  },
  beforeDestroy() {
    eventBus.$off('switch-chart');
    eventBus.$off('data-source');
    eventBus.$off('accumulated-report');
  },
};
</script>

<style lang="scss" scoped>
.right-switch {
  text-align: right;
  margin-top: 10px;
  position: absolute;
  z-index: 999;
  right: 40px;
}

.loader {
  width: 100%;
  height: 350px;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;

}

.start-page{margin-top: 5rem;}
</style>



// WEBPACK FOOTER //
// src/components/molecules/highcharts/reports/invites-evolution.vue